
export const LOAD_PROFILES = 'LOAD_PROFILES'

export default {
	[LOAD_PROFILES] (state, payload) {
		state.list = payload
	}
}
